module.exports = __webpack_public_path__ + "img/AbuDhabi.28faa3ba.png";